(function () {
  "use strict";

  var root = document.getElementById("rn-cheetah-stories-root");
  if (!root) return;

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = root.querySelectorAll(".reveal:not(.visible)");
    if (reduceMotion || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("visible"); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("visible"); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- Countdown ---------- */
  function initCountdown() {
    var endStr = root.getAttribute("data-cd-end");
    var expiredText = root.getAttribute("data-cd-expired") || "";
    var target = endStr ? new Date(endStr).getTime() : NaN;
    var groups = root.querySelectorAll("[data-countdown]");
    if (!groups.length || isNaN(target)) return;

    function pad(n) { return (n < 10 ? "0" : "") + n; }

    function render() {
      var diff = target - Date.now();
      if (diff <= 0) {
        groups.forEach(function (g) {
          g.innerHTML = '<span class="rn-countdown__caption" style="margin:0;">' + expiredText + "</span>";
        });
        return true; // done
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      groups.forEach(function (g) {
        var d = g.querySelector('[data-cd="days"]');
        var h = g.querySelector('[data-cd="hours"]');
        var m = g.querySelector('[data-cd="mins"]');
        var s = g.querySelector('[data-cd="secs"]');
        if (d) d.textContent = pad(days);
        if (h) h.textContent = pad(hours);
        if (m) m.textContent = pad(mins);
        if (s) s.textContent = pad(secs);
      });
      return false;
    }

    if (render()) return;
    var timer = setInterval(function () { if (render()) clearInterval(timer); }, 1000);
  }

  /* ---------- Hero zoom-in + sticky bar ---------- */
  function initHeroSticky() {
    var hero = root.querySelector("[data-hero]");
    var sticky = root.querySelector("[data-sticky]");
    if (hero) {
      requestAnimationFrame(function () { hero.classList.add("is-in"); });
    }
    if (!hero || !sticky || !("IntersectionObserver" in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) sticky.classList.remove("is-visible");
        else sticky.classList.add("is-visible");
      });
    }, { threshold: 0, rootMargin: "-80px 0px 0px 0px" });
    obs.observe(hero);
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    var items = root.querySelectorAll("[data-faq-item]");
    items.forEach(function (item) {
      var q = item.querySelector("[data-faq-q]");
      var a = item.querySelector(".rn-faq__a");
      if (!q || !a) return;
      q.addEventListener("click", function () {
        var isOpen = item.classList.contains("is-open");
        items.forEach(function (other) {
          other.classList.remove("is-open");
          var oa = other.querySelector(".rn-faq__a");
          var oq = other.querySelector("[data-faq-q]");
          if (oa) oa.style.maxHeight = null;
          if (oq) oq.setAttribute("aria-expanded", "false");
        });
        if (!isOpen) {
          item.classList.add("is-open");
          a.style.maxHeight = a.scrollHeight + "px";
          q.setAttribute("aria-expanded", "true");
        }
      });
    });
  }

  /* ---------- Timeline fill + step activation ---------- */
  function initTimeline() {
    var timeline = root.querySelector("[data-timeline]");
    if (!timeline) return;
    var fill = timeline.querySelector("[data-timeline-fill]");
    var steps = timeline.querySelectorAll("[data-step]");
    if (reduceMotion) {
      if (fill) fill.style.height = "100%";
      steps.forEach(function (s) { s.classList.add("is-active"); });
      return;
    }
    function onScroll() {
      var rect = timeline.getBoundingClientRect();
      var vh = window.innerHeight;
      var progress = (vh * 0.6 - rect.top) / rect.height;
      progress = Math.max(0, Math.min(1, progress));
      if (fill) fill.style.height = progress * 100 + "%";
      steps.forEach(function (s, i) {
        var sr = s.getBoundingClientRect();
        if (sr.top < vh * 0.7) s.classList.add("is-active");
      });
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
  }

  /* ---------- Milestones progress fill ---------- */
  function initMilestones() {
    var track = root.querySelector("[data-milestones]");
    var fill = root.querySelector("[data-milestones-fill]");
    if (!track || !fill) return;
    if (reduceMotion || !("IntersectionObserver" in window)) { fill.style.width = "100%"; return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { fill.style.width = "100%"; obs.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    obs.observe(track);
  }

  /* ---------- Checklist sequential ---------- */
  function initChecklist() {
    var card = root.querySelector("[data-checklist]");
    if (!card) return;
    var checks = card.querySelectorAll("[data-check]");
    if (reduceMotion || !("IntersectionObserver" in window)) {
      checks.forEach(function (c) { c.classList.add("is-on"); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          checks.forEach(function (c, i) {
            setTimeout(function () { c.classList.add("is-on"); }, i * 260);
          });
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });
    obs.observe(card);
  }

  function init() {
    initReveal();
    initCountdown();
    initHeroSticky();
    initFaq();
    initTimeline();
    initMilestones();
    initChecklist();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
